export const formatClientCode = (code) => {
    if (!code) return "";
    return code.match(/.{1,4}/g)?.join("-") || code;
};